<template>
  <div class="card form-sign-in check-pin">
    <div class="card-body text-center" v-if="loading === true">
      <loading/>
      <span class="d-block mt-2">{{t('Loading')}}</span>
    </div>
    <div v-if="loading === false">
      <div class="ask-parent" v-if="stage === 'ask-parent'">
        <span>{{askParentText1}}</span>
        <span>{{askParentText2}}</span>
        <button @click="backToLogin" class="btn btn-primary continue-btn">{{t('Back to login page')}}</button>
      </div>
      <div v-if="stage === 'confirm'">
        <div class="card-header">{{t('Contact information check')}}</div>
        <div class="card-body">
          <span class="info" v-if="fCheckPinOnly === false" v-html="t('_CheckContactInfoTxt')"></span>
          <span class="info" v-if="fCheckPinOnly === true" v-html="t('Check pin only...')"></span>
          <titan-form ref="checkPinForm"
                      :schema="getSchema"
                      :renderInCard="false"
                      :model="verifyInfoModel"
                      @saveData="sendForm()"
          />

          <button type="button" class="btn btn-primary btn-block" @click="sendForm()">
            {{t('Confirm')}}
          </button>
        </div>
      </div>
      <div v-if="stage === 'cellphone'">
        <div class="card-header">{{t('Cellphone')}}</div>
        <div class="card-body">
          <titan-form ref="checkPinForm"
                      :schema="getSchema"
                      :renderInCard="false"
                      :model="cellphoneModel"
                      @saveData="sendForm()"
          />

          <button type="button" class="btn btn-primary btn-block" @click="sendForm()">
            {{t('Send security PIN')}}
          </button>
        </div>
      </div>
      <div v-if="stage === 'security-pin'">
        <div class="card-header">{{t('Security PIN')}}</div>
        <div class="card-body">
          <span class="info" v-if="fCheckPinOnly === false" v-html="t('_SecPinTxt')"></span>
          <span class="info" v-if="fCheckPinOnly === true"
                v-html="t('We did not find your security PIN on this device. Please enter the 6-digit number in the field below.')"></span>
          <titan-form ref="checkPinForm"
                      :schema="getSchema"
                      :renderInCard="false"
                      :model="securityPinModel"
                      @saveData="sendForm()"
          />
          <button type="button" class="btn btn-primary btn-block" @click="sendForm()">{{t('Verify PIN')}}</button>
          <div v-if="fCheckPinOnly === true && recoveryMailSent === false" class="additional-actions row no-gutters justify-content-md-center" >
            <div class="no-pin">{{t('Cannot remember your security PIN? Click the \"Recover\" link')}}</div>
            <button v-if="recoveryMailSent === false" type="button" class="text-right col-3 btn btn-link btn-block" @click="recoverPin()">{{t('Recover')}}</button>
            <div v-if="recoveryMailSent === false" class="col-auto delimiter">|</div>
            <button type="button" class="text-left col-3 btn btn-link btn-block" @click="logOut()">{{t('Log out')}}</button>
          </div>
          <div class="no-pin" v-if="recoveryMailSent === true">{{t('We sent a recovery link o your e-mail address. Please click the link and follow the further instructions.')}}</div></div>

        <div v-if="fCheckPinOnly === false">
          <span class="info d-flex justify-center justify-content-center">{{t('Did not get the sms?')}} {{t('Click one of the links below to re-send the code via sms or e-mail.')}}</span>
          <span v-if="this.pinResent === 'sms'" class="info d-flex justify-center justify-content-center">{{t('Message was sent. Please check your incoming text messages.')}}</span>
          <span v-if="this.pinResent === 'email'" class="info d-flex justify-center justify-content-center">{{t('Message was sent. Please check your mailbox.')}}</span>

          <span v-if="!reSendEnabled" class="info d-flex justify-center justify-content-center">{{t('Re-send PIN will be possible in')}} {{this.resendCounter}} {{t('seconds')}}</span>
          <div class="d-flex justify-content-center justify-center additional-actions">
            <button type="button" :disabled="!this.reSendEnabled" class="btn btn-link " @click="reSendSms()">{{t('Re-send sms')}}</button>
            <div class="delimiter">|</div>
            <button type="button" :disabled="!this.reSendEnabled"class="btn btn-link " @click="emailMeInstead()">{{t('E-mail me instead')}}</button>
            <div class="delimiter">|</div>
            <button type="button" class="btn btn-link " @click="logOut()">{{t('Log out')}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import VueFormGenerator from 'vue-form-generator'
    import TitanForm from '../../core/Form/Form'
    import CryptoJS from 'crypto-js'
    import Loading from '../../core/Components/loading'

    export default {
        components: {
            Loading,
            TitanForm,
        },
        data() {
            return {
                loading: true,
                account: null,
                stage: 'confirm',
                knownValue: 'publiclySafeString',
                checkPinOnly: false,
                recoveryMailSent: false,
                resendCounter: 30,
                pinResent: null,
                schema: {
                    name: '',
                    type: 'main',
                    fields: [],
                },
                securityPinModel: {
                    securityPin: null,
                },
                securityPinFields: [
                    {
                        type: 'input',
                        inputType: 'number',
                        label: this.t('Security PIN'),
                        model: 'securityPin',
                        required: true,
                        validator: (value) => {
                            if (value) {
                                return null === value.toString().match(/^[0-9]{6}$/) ? [this.t('Value must be a 6 digit number')] : [];
                            } else {
                                return [this.t('Please enter your PIN number')];
                            }
                        },

                    },
                ],
                cellphoneModel: {},
                cellphoneFields: [
                    {
                        type: 'input',
                        inputType: 'text',
                        label: this.t('Cellphone'),
                        model: 'cellphone',
                        placeholder: '0900123456',
                        required: true,
                        validator: (value) => {
                            if (value) {
                                return null === value.match(/^[0-9]{10}$/) ? [this.t('Value must match format "0900123456"')] : [];
                            } else {
                                return [this.t('Please enter your mobile phone number')];
                            }
                        }
                    },
                ],
                verifyInfoModel: {},
                verifyInfoFields: [
                    {
                        type: 'input',
                        inputType: 'text',
                        label: this.t('Degree'),
                        styleClasses: 'col-2',
                        model: 'titlePrefix',
                        required: false,
                        max: 40,
                        validator: VueFormGenerator.validators.string,
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.t('Firstname'),
                        styleClasses: 'col-4',
                        model: 'firstname',
                        required: true,
                        validator: VueFormGenerator.validators.required,
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.t('Lastname'),
                        styleClasses: 'col-4',
                        model: 'lastname',
                        required: true,
                        validator: VueFormGenerator.validators.required,
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.t('Degree'),
                        styleClasses: 'col-2',
                        model: 'titleSufix',
                        required: false,
                        max: 40,
                        validator: VueFormGenerator.validators.string,
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.t('E-mail'),
                        styleClasses: 'col-6',
                        model: 'login',
                        required: true,
                        validator: VueFormGenerator.validators.email
                    }, {
                        type: 'input',
                        inputType: 'text',
                        label: this.t('Mobile phone'),
                        styleClasses: 'col-6',
                        required: !this.skipSecurityInit(),
                        model: 'cellphone',
                        validator: (value) => {
                            if (this.skipSecurityInit()) {
                                return [];
                            } else {
                                if (value) {
                                    return null === value.match(/^[0-9]{10}$/) ? [this.t('Value must match format "0900123456"')] : []
                                } else {
                                    return [this.t('Please enter your mobile phone number')]
                                }
                            }

                        }
                    }
                ],
            }
        },
        methods: {
            backToLogin() {
                this.$router.push({name: 'login'});
            },
            recoverPin() {
                this.$store.dispatch('log/log', {
                    'name': 'user.requestedPinRecovery'
                });
                this.$store.dispatch('account/sendPinRecoveryMail').then(response => {
                    if (response.status === 200 && response.data.status === true) {
                        this.recoveryMailSent = true;
                    }
                });
            },
            logOut() {
                this.getUserStore().getLoggedUser().logOut();
                this.$router.push({name: 'login'});
            },
            emailMeInstead() {
                this.createSecurityPin('email');
                this.resendCounter = 30;
                this.pinResent = 'email';
            },
            reSendSms() {
                this.createSecurityPin('sms');
                this.resendCounter = 30;
                this.pinResent = 'sms';
            },
            skipSecurityInit() {
                let user = this.$store.state.account.user;
                if (user.hasOwnProperty('skipSecurityInit') && user.skipSecurityInit === true) {
                    return true;
                }
                return false;
            },
            init() {
                setInterval(() => {
                    if(this.resendCounter > 0) {
                        this.resendCounter--;
                    }
                },1000);
                const pin = this.getUserStore().getLoggedUser().get('securityPin');
                if (null !== pin) {
                    this.$router.push({name: 'twoFactorAuth'})
                    return
                }

                this.$store.dispatch('account/get').then(response => {
                    const account = response
                    this.account = account;
                    if (account.parent && !account.securityPinSet) {
                        this.stage = 'ask-parent'
                    } else if (account.verifiedAccountAt === null) {
                        this.stage = 'confirm'
                    } else if (account.securityPinSet === false) {
                        this.createSecurityPin('sms');
                        this.stage = 'security-pin'
                    } else {
                        this.checkPinOnly = true;
                        this.stage = 'security-pin'
                    }

                    if (this.stage !== 'ask-parent') {
                        this.verifyInfoFields
                            .forEach(field => {
                                if (field && field.model) {
                                    this.verifyInfoModel[field.model] = account[field.model]
                                }
                            })

                        this.cellphoneModel['cellphone'] = account.cellphone
                    }
                    this.loading = false
                })
            },
            handleInfoConfirmation() {
                this.$store.dispatch('account/verifyInfo', this.verifyInfoModel).then(() => {
                    this.$store.dispatch('log/log', {
                        'name': 'user.confirmedContactData',
                        'context': JSON.stringify(this.verifyInfoModel)
                    });
                    this.$store.dispatch('account/get').then(account => {
                        this.loading = false;
                        this.stage = 'security-pin';
                        if (account.securityPinSet === false) {
                            this.createSecurityPin('sms')
                        } else {
                            this.checkPinOnly = true;
                        }
                    })
                }).catch(error => {
                    this.loading = false
                    this.$store.dispatch('alert/error', error.data.status)
                })
            },
            createSecurityPin(channel) {
                this.$store.dispatch('account/sendSecurityPin',{'channel':channel})
                    .then(response => {
                        if (response.hasOwnProperty('pin')) {
                            this.securityPinModel.securityPin = response.pin;
                        }
                        this.$store.dispatch('account/get').then(response => {
                            this.loading = false
                            if (response.error) {
                                this.$store.dispatch('alert/error', response.status)
                                return
                            }
                            this.stage = 'security-pin'
                        })
                    }).catch(error => {
                    this.loading = false
                    this.$store.dispatch('alert/error', error.status)
                })
            },
            handleSecurityPin() {
                let account = this.$store.getters['account/account'];
                if (!account.securityPinSet) {
                    this.$store.dispatch('account/setClientPin', this.securityPinModel).then(response => {
                        this.loading = false
                        if (response.data.error) {
                            this.$store.dispatch('log/log', {
                                'name': 'user.setFirstPinIncorrect',
                                'context': this.securityPinModel.securityPin
                            });
                            this.$store.dispatch('alert/error', response.data.status)
                        } else {
                            let securityPin = this.securityPinModel.securityPin;
                            this.$store.dispatch('log/log', {
                                'name': 'user.setFirstPinCorrect'
                            });
                            this.$store.dispatch('alert/success', response.data.status)
                            this.getUserStore().getLoggedUser().set('securityPin', securityPin);
                            this.$router.push({name: 'twoFactorAuth'});
                        }
                    }).catch(error => {
                        this.loading = false
                        this.$store.dispatch('alert/error', error.data ? error.data.status : error)
                    })
                } else {
                    let pin = CryptoJS.enc.Utf8.parse(this.securityPinModel.securityPin);
                    this.$store.dispatch('account/verifyClientPin', {'pinHash': CryptoJS.SHA512(pin).toString()})
                        .then(response => {
                            this.loading = false
                            if (response.data.error) {
                                if (response.data.status === 'Provided PIN is incorrect') {
                                    this.$store.dispatch('log/log', {
                                        'name': 'user.setAgainPinIncorrect',
                                        'context': this.securityPinModel.securityPin
                                    });
                                }
                                this.$store.dispatch('alert/error', response.data.status)
                            } else {
                                this.$store.dispatch('log/log', {
                                    'name': 'user.setAgainPinCorrect'
                                });
                                this.$store.dispatch('alert/success', response.data.status)
                                this.getUserStore().getLoggedUser().set('securityPin', this.securityPinModel.securityPin);
                                this.$router.push({name: 'twoFactorAuth'});
                            }
                        });
                }
            },
            sendForm() {
                if (false === this.$refs.checkPinForm.isValid()) {
                    return
                }
                this.loading = true
                if (this.stage === 'confirm') {
                    this.handleInfoConfirmation()
                }
                if (this.stage === 'security-pin') {
                    this.handleSecurityPin()
                }
            },
        },
        computed: {
            getSchema() {
                const schema = this.schema
                if (this.stage === 'confirm') {
                    schema.fields = this.verifyInfoFields
                } else if (this.stage === 'cellphone') {
                    schema.fields = this.cellphoneFields
                } else if (this.stage === 'security-pin') {
                    schema.fields = this.securityPinFields
                }

                return [schema]
            },
            fCheckPinOnly() {
                return this.checkPinOnly;
            },
            askParentText1() {
                let greeting = this.t('Dear missis / mister');
                if (['male', 'female'].includes(this.account.sex)) {
                    greeting = this.account.sex === 'female' ? this.t('Dear missis') : this.t('Dear mister');
                }
                return this.t('{greeting} {sub-user-name}, we recently enhanced system\'s security. In order to proceed, main user\'s assistance is needed.')
                    .replace('{sub-user-name}', this.account.fullName)
                    .replace('{greeting}', greeting);
            },
            askParentText2() {
                return this.t('Please ask "{parent-user-name}" to log in and activate the account').replace('{parent-user-name}', this.account.parent.fullName);
            },
            reSendEnabled() {
                return this.resendCounter === 0;
            }
        },
        created() {
            this.init()
        },
    }
</script>

<style lang="scss">
  .check-pin {
    .additional-actions {
        padding-bottom: 1rem;
        .btn, .delimiter {
          padding: .375rem .375rem;
        }
    }

    .info {
      display: block;
      font-size: 0.9em;
      color: gray;
      padding-bottom: 10px;
    }

    .no-pin {
      text-align: center;
      margin-top: 10px;
      font-size: 0.9em;
      color: gray;
    }

    .ask-parent {
      text-align: center;
      padding: 2rem;

      > span {
        display: block;
        padding: 0.8rem;
        text-align: center;
      }
    }

    .continue-btn {
      margin-top: 1rem;
    }
  }


</style>




// WEBPACK FOOTER //
// src/pages/private/CheckPin.vue